import axios from 'axios'

/**
 * 获取其他消息
 * @returns {Promise<any>}
 */
export async function otherCount() {
  const result = await axios.get('/userCenter/letter/otherCount', {})
  return result.data
}

/**
 * 拉取总个数
 * @returns {Promise<any>}
 */
export async function letterCount() {
  const result = await axios.post('/ecoSystem/api/v1/letter/count')
  return result.data
}

/**
 * 站内信标记已读删除
 * @param data
 * @returns {Promise<any>}
 */
export async function letterReadOrDelete(data) {
  const result = await axios.post('/ecoSystem/api/v1/letter/readOrDelete', data)
  return result.data
}

/**
 * 消息列表
 * @param data
 * @returns {Promise<any>}
 */
export async function letterQuery(data) {
  const result = await axios.post('/ecoSystem/api/v1/letter/query', data)
  return result.data
}
